export default __webpack_public_path__ + "static/media/chevron-left.7ad0509c.svg";